import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useForm, setValue } from 'react-hook-form';
import * as actions from '../actions/communicationmoduleactions'
import UseEntryDetails from '../views/userdetails'
export default function UserEntry() {


    const state = useSelector(state => state.communicationModuleReducer)
    let userEntry = state.userEntry;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { register: registerUserEntry,
        reset: resetUserEntry, handleSubmit: submitUserEntry, setValue: setUserEntryValue, formState: { errors: errorUserEntry } } = useForm();


    const [disabled, setDisabled] = useState(false);
    const [seconds, setSeconds] = useState(0);


    useEffect(() => {
        let valuesToMap = [
            { "mobileNo": userEntry.mobileNo },
            { "otpCode": userEntry.otpCode },
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setUserEntryValue(key, i[key])));
    }, [userEntry]);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const value1 = params.get("refLink"); // change key name

        if (value1 && value1.trim() !== "") {
            let name = "linkId";
            let value = value1;
            dispatch(actions.onChangeUserEntryParams({ name, value }));
        }
    }, [location.search]);


    const onUserEntrySubmit = async (data, e) => {
await  dispatch(actions.validateOtpForCommunication());


    }
    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const onSendOtpCode = async() => {
        let val = isValidNumber(userEntry.mobileNo);
        if (!val) {
            alert("Invalid Number")
        }
     let res=  await  dispatch(actions.createOtpForCommunication());
     if(res==true)
     {
          {let name="otpCodeSent";
                        let value="Y";
                        dispatch(actions.onChangeUserEntryParams({ name, value }));
          }
        
        setDisabled(true);
        setSeconds(5); // 1 minute
     }
     
    }

    useEffect(() => {
        let timer;

        if (seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prev) => prev - 1);
            }, 1000);
        } else if (seconds === 0 && disabled) {
            setDisabled(false);
        }

        return () => clearInterval(timer);
    }, [seconds, disabled]);
    function isValidNumber(value) {
        return /^0\d{9}$/.test(value);
    }
    const onErrorUserEntry = (errorUserEntry, e) => console.log(errorUserEntry, e);
    const onChangeUserEntryParams = (e) => {
        let { name, value } = e.target;
        dispatch(actions.onChangeUserEntryParams({ name, value }));
    }
    if(userEntry.linkId == null || userEntry.linkId == '') 
{
    return(<h1>Invalid Link</h1>)
}
    let MobileNo = <input className={errorUserEntry.mobileNo ? 'form-control  is-invalid' : 'form-control'}
        name="mobileNo"
        id="mobileNo"
        disabled={false}
        type="number"
        placeholder="Mobile No"
        {...registerUserEntry("mobileNo", {
            required: true,
            pattern: {
                value: /^0\d{0,9}$/,
                message: "Must start with 0 and be up to 10 digits"
            }, onChange: (e) => onChangeUserEntryParams(e)
        })}
    />
    let OtpCode = <input className={errorUserEntry.otpCode ? 'form-control  is-invalid' : 'form-control'}
        name="otpCode"
        id="otpCode"
        disabled={false}
        type="text"

        placeholder="Otp Code"
        {...registerUserEntry("otpCode", {
            required: true,
            pattern: {
                value: /^[a-zA-Z0-9]{1,7}$/,
                message: "Only letters and numbers allowed (max 7 characters)"
            }
            , onChange: (e) => onChangeUserEntryParams(e)
        })}
    />

    return (

        <>
        {userEntry.isValidated ==="Y" && <div><UseEntryDetails/></div>}
            {/*(userEntry.linkId == null || userEntry.linkId == '') ? <h1>Invalid link</h1> :*/
                userEntry.isValidated !=="Y" && <div>
                    
                    <ul className="nav nav-tabs nav-bordered mb-3">
                    </ul>
                    <body /*data-layout-config="{&quot;darkMode&quot;:false}" data-layout-color="light"*/>

                        <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                            <div class="container">
                                <div class="row justify-content-center">
                                    <div class="col-xxl-6 col-lg-5">
                                        <div class="card">

                                            <div class="card-body p-4">

                                                <span class="logo-lg d-block mb-3">
                                                    <div class="text-center w-75 m-auto">
                                                        <h4 class="text-black text-center mt-0 mb-3 fw-bold"> Welcome! Enter your registered mobile number to continue.</h4>
                                                    </div>
                                                </span>
                                                <ul className="nav nav-tabs nav-bordered my-3">
                                                </ul>


                                                <form className="form-group collapse show"
                                                    onSubmit={submitUserEntry(onUserEntrySubmit, onErrorUserEntry)}
                                                    id="ColapseTargetComplaintDetails">

                                                    <div className="mb-3">

                                                        <label for="inputPassword4" className="form-label"> Mobile Number/رقم الهاتف المحمول</label>
                                                        <div className="input-group">
                                                            {MobileNo}
                                                            <button type="button" class="btn btn-info"
                                                                onClick={() => onSendOtpCode()} disabled={disabled}> <i className="dripicons-message">   {disabled ? `Resend in ${seconds}s` : "Send OTP"}</i></button>

                                                            {errorUserEntry.mobileNo?.message && <span>{errorUserEntry.mobileNo?.message}</span>}
                                                        </div>
                                                    </div>
                                                    {userEntry.otpCodeSent =="Y" &&<div className="mb-3">
                                                        <label for="inputPassword4" className="form-label"> OTP Code/رمز التحقق</label>
                                                        {OtpCode}
                                                        {errorUserEntry.otpCode?.message && <span>{errorUserEntry.otpCode?.message}</span>}
                                                    </div>}






                                                   {userEntry.otpCodeSent =="Y" && <div id="tooltip-container2">
                                                        <button type="submit" className="btn btn-success float-end"
                                                            data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Save" ><i className="mdi mdi-content-save-outline"></i> Validate</button>
                                                    </div>}


                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </body>
                </div>
                }
        </>
    )
}
